import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'flowaccount-flowpay-good-point',
  templateUrl: './flowpay-good-point.component.html',
  styleUrls: ['./flowpay-good-point.component.scss']
})
export class FlowpayGoodPointComponent implements OnInit {

  ngOnInit(): void {
  }

  loopArray(index) {
    return new Array(index)
  }



}
